<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="Heading-1" id="_idParaDest-8"><a id="_idTextAnchor008"></a>The Problem of Other Minds</h1>
<p class="Verse-new">What do we learn when you take me to you?</p>
<p class="Verse-main">I want to discover all that we can,</p>
<p class="Verse-main">Since coupling divides as well as unites.</p>
<p class="Verse-new">Neither of us knows what the other feels.</p>
<p class="Verse-main">We just decipher signs … if we notice …</p>
<p class="Verse-main">And how can you be sure you got them right?</p>
<p class="Verse-new">If it’s not going down, whose fault is that?</p>
<p class="Verse-main">You’ll shoot back, ‘That’s a man talking, all right’.</p>
<p class="Verse-main">But, wait! Hold on. Tell me, how do you judge?</p>
<p class="Verse-new">Since, unlike the body, the brain’s intact,</p>
<p class="Verse-main">Not to be breached by foolproof probes, and live?</p>
<p class="Verse-main">We lie every day about what we feel.</p>
<p class="Verse-new">We live in a bubble of assumptions,</p>
<p class="Verse-main">Or try to anyway, inferring likeness—</p>
<p class="Verse-main">One like another?—day in and day out,</p>
<p class="Verse-new">But likeness is a worn, often shabby</p>
<p class="Verse-main">Garment that hides implacable hatred</p>
<p class="Verse-main">As old as pissing to mark a thing yours.</p>
<p class="Verse-new">‘The problem of other minds,’ philosophy</p>
<p class="Verse-main">Has taught us to call it. Most of us laugh,</p>
<p class="Verse-main">Or at any rate smile—why should we care?</p>
<p class="Verse-new">Each will take what he or she wants, and some</p>
<p class="Verse-main">Won’t think twice about killing for it—</p>
<p class="Verse-main">Murder pleases so many so fully</p>
<p class="Verse-new">It’s a blunder we don’t rename it ‘god’</p>
<p class="Verse-main">And replace our churches with armories,</p>
<p class="Verse-main">Sunday School with Gun-day School—prey for all!</p>
<p class="Verse-new">Even god is murdered, by both church and state.</p>
<p class="Verse-main">Still called ‘The Son of Man’, and by his Abba called,</p>
<p class="Verse-main">He knew the answer to being apart:</p>
<p class="Verse-new">Not just seven but seventy times seven,</p>
<p class="Verse-main">Not just between us but between us all—</p>
<p class="Verse-main">Forgiveness is love’s imperfect knowledge.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB-8.vue?24a69dd9